import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const failedAttempts = ['Comprar cristales y amuletos sin entender el flujo del Qi no cambia la estructura de tu descanso.', 'Limpiar el desorden superficial no sirve si tienes "ruido visual" bajo tu cama afectando tu mente subconsciente.', 'Mover muebles al azar sin una estrategia arquitectónica solo cambia el lugar del problema, no la raíz.'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white relative" data-id="element-115">
      <div className="max-w-4xl mx-auto" data-id="element-116">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="space-y-16" data-id="element-117">
          {/* Opening Hook */}
          <motion.div variants={itemVariants} className="text-center" data-id="element-118">
            <p className="text-xl sm:text-2xl font-serif italic text-charcoal leading-relaxed" data-id="element-119">
              "¿Alguna vez has sentido que, por más que trabajas, la energía en
              tu casa se siente 'pesada'? Duermes 8 horas pero despiertas
              cansada. El dinero llega, pero parece escaparse por grietas
              invisibles."
            </p>
            <p className="mt-6 text-lg text-sage font-medium" data-id="element-120">
              No es falta de voluntad. Es tensión ambiental. Tu hogar es un
              organismo vivo: si la energía no fluye, tu vida se estanca.
            </p>
          </motion.div>

          {/* The Problem */}
          <motion.div variants={itemVariants} className="bg-cream rounded-2xl p-8 sm:p-12 shadow-sm border border-gold/10" data-id="element-121">
            <h2 className="text-2xl sm:text-3xl font-serif text-charcoal mb-6 text-center" data-id="element-122">
              El error de la decoración superficial
            </h2>
            <p className="text-charcoal/80 text-lg leading-relaxed" data-id="element-123">
              Muchos cometen el error de pensar que el Feng Shui es misticismo o
              decoración costosa. La realidad es más simple: si tu cama está en
              una mala posición o tu puerta principal está obstruida, estás
              viviendo en un espacio que drena tu vitalidad en lugar de
              multiplicarla.
            </p>
          </motion.div>

          {/* Failed Attempts */}
          <motion.div variants={itemVariants} className="space-y-8" data-id="element-124">
            <h3 className="text-2xl font-serif text-center text-charcoal" data-id="element-125">
              Por qué lo que intentaste no funcionó
            </h3>
            <div className="grid gap-4 sm:gap-6" data-id="element-126">
              {failedAttempts.map((attempt, index) => <motion.div key={index} variants={itemVariants} className="flex items-start p-6 bg-white rounded-xl border border-sage/20 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-127">
                  <div className="flex-shrink-0 mt-1" data-id="element-128">
                    <div className="w-8 h-8 rounded-full bg-terracotta/10 flex items-center justify-center" data-id="element-129">
                      <XIcon className="w-5 h-5 text-terracotta" aria-hidden="true" data-id="element-130" />
                    </div>
                  </div>
                  <p className="ml-4 text-charcoal/80 text-lg leading-relaxed" data-id="element-131">
                    {attempt}
                  </p>
                </motion.div>)}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}